import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, inject, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@app/app.service';
import { Gallery, GalleryItem, GalleryRef, ImageItem, ImageSize } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { enterFullScreen, exitFullScreen } from '../../../shared/helpers/common-helpers';
import { downloadFile } from '../../../shared/helpers/download-helpers';

@Component({
    selector: 'app-images-dialog',
    templateUrl: './images-dialog.component.html',
    styleUrls: ['./images-dialog.component.scss'],
    providers: [Lightbox],
})
export class ImagesDialogComponent implements OnInit, AfterViewInit {
    /** Основная галерея */
    public galleryRef: GalleryRef;

    /** Галерея в лайтбоксе */
    public lightboxRef: GalleryRef;

    /** Флаг открытия полноэкранного режима */
    public isFullScreen: boolean = false;

    /** Сервис взаимодействия с внешними ресурсами */
    public appService: AppService = inject(AppService);

    /** Галерея */
    public gallery: Gallery = inject(Gallery);

    /** Лайтбокс */
    public lightbox: Lightbox = inject(Lightbox);

    /**
     * Конструктор
     * @param dialogRef ссылка на диалог
     * @param document документ
     * @param data данные диалога
     */
    constructor(
        public dialogRef: MatDialogRef<ImagesDialogComponent>,
        @Inject(DOCUMENT) private document: Document,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            files: any[];
            index: number;
        },
    ) {}

    /** Изображения для галереи */
    images: GalleryItem[] = [];

    /** Шаблон лайтбокса */
    @ViewChild('lightboxTemplate', { read: TemplateRef }) lightboxTemplate: TemplateRef<any>;

    ngOnInit() {
        this.images = this.data.files.map((file) => new ImageItem({ src: file.big, thumb: file.small }));
    }

    ngAfterViewInit() {
        this.galleryRef = this.gallery.ref('gallery');
        this.lightboxRef = this.gallery.ref('lightbox');

        this.lightboxRef.setConfig({
            imageSize: ImageSize.Cover,
            thumb: false,
            boxTemplate: this.lightboxTemplate,
        });
    }

    /**
     * Закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }

    /**
     * Закрыть лайтбокс
     */
    closeLightbox() {
        this.lightbox.close();
    }

    /**
     * Скачать текущее изображение в лайтбоксе
     */
    downloadCurrentLightbox() {
        const currentIndex = this.lightboxRef.stateSnapshot.currIndex;
        const image = this.images[currentIndex].data.src;
        downloadFile(image);
    }

    /**
     * Переключение полноэкранного режима в лайтбоксе
     */
    toggleLightboxFullScreen() {
        if (this.isFullScreen) {
            exitFullScreen();
        } else {
            const lightboxElement = this.document.querySelector('lightbox');
            enterFullScreen(lightboxElement);
        }
        this.isFullScreen = !this.isFullScreen;
    }
}
